import { useState, ReactNode } from 'react'

export interface HeaderDropdownItem {
  label: string
  icon?: ReactNode
  onClick: () => void
}

interface HeaderDropdownProps {
  trigger: ReactNode
  items: HeaderDropdownItem[]
  ariaLabel: string
  triggerClassName?: string
  align?: 'left' | 'right'
}

export default function HeaderDropdown({
  trigger,
  items,
  ariaLabel,
  triggerClassName,
  align = 'right',
}: HeaderDropdownProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <div className="relative shrink-0">
        <button
          type="button"
          onClick={() => setIsOpen(prev => !prev)}
          className={triggerClassName ?? 'cursor-pointer'}
          aria-label={ariaLabel}
        >
          {trigger}
        </button>

        {isOpen && (
          <div
            className={`absolute top-full mt-2 bg-background-primary border border-border-primary border-solid rounded-lg shadow-lg z-50 min-w-[180px] ${
              align === 'right' ? 'right-0' : 'left-0'
            }`}
          >
            {items.map((item, index) => (
              <button
                type="button"
                key={item.label}
                onClick={() => {
                  item.onClick()
                  setIsOpen(false)
                }}
                className={`w-full flex gap-[8px] items-center px-[16px] py-[12px] text-left hover:bg-background-tertiary transition-colors rounded-lg text-text-primary-900${
                  index < items.length - 1
                    ? ' border-b border-border-primary'
                    : ''
                }`}
              >
                {item.icon}
                <span className="font-body font-medium text-md text-text-primary-900">
                  {item.label}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>

      {isOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  )
}
